/**
 * Valida un RUT chileno usando el algoritmo Módulo 11.
 * Acepta formatos: 12345678-9, 123456789, 12.345.678-9
 * @param {string} rut
 * @returns {boolean}
 */
export function validarRut(rut) {
  if (!rut || typeof rut !== 'string') return false;

  // Limpiar puntos, guiones y espacios
  const limpio = rut.replace(/[.\-\s]/g, '').toUpperCase();
  if (limpio.length < 2) return false;

  const dv = limpio.slice(-1);         // último caracter = dígito verificador
  const cuerpo = limpio.slice(0, -1);  // el resto = número

  if (!/^\d+$/.test(cuerpo)) return false;
  if (!/^[\dK]$/.test(dv)) return false;
  if (parseInt(cuerpo, 10) < 1000000) return false; // RUT mínimo válido

  // Calcular dígito verificador
  let suma = 0;
  let factor = 2;
  for (let i = cuerpo.length - 1; i >= 0; i--) {
    suma += parseInt(cuerpo[i], 10) * factor;
    factor = factor === 7 ? 2 : factor + 1;
  }
  const resto = 11 - (suma % 11);
  const dvEsperado = resto === 11 ? '0' : resto === 10 ? 'K' : String(resto);

  return dv === dvEsperado;
}

/**
 * Formatea un RUT limpio al formato estándar 12.345.678-9
 * @param {string} rut
 * @returns {string}
 */
export function formatearRut(rut) {
  const limpio = rut.replace(/[.\-\s]/g, '').toUpperCase();
  if (limpio.length < 2) return rut;
  const dv = limpio.slice(-1);
  const cuerpo = limpio.slice(0, -1);
  const cuerpoFormato = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${cuerpoFormato}-${dv}`;
}

/**
 * Valida formato de email.
 * @param {string} email
 * @returns {boolean}
 */
export function validarEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
}

/**
 * Detecta si un texto contiene palabras prohibidas (incluye modismos chilenos).
 * @param {string} texto - El texto a analizar.
 * @param {string} listaProhibida - String de palabras separadas por comas.
 * @returns {string|null} - Retorna la palabra encontrada o null si es seguro.
 */
export function contienePalabrasOfensivas(texto, listaProhibida) {
  if (!texto || !listaProhibida) return null;
  
  const palabras = listaProhibida.split(',').map(p => p.trim().toLowerCase()).filter(p => p.length > 0);
  const textoLimpio = texto.toLowerCase();

  // Usamos regex para buscar palabras completas y evitar falsos positivos (como "biblioteca")
  for (const palabra of palabras) {
    const regex = new RegExp(`\\b${palabra}\\b`, 'i');
    if (regex.test(textoLimpio)) {
      return palabra;
    }
    // Caso especial para modismos pegados o variaciones comunes
    if (textoLimpio.includes(palabra) && palabra.length > 4) {
      return palabra;
    }
  }

  return null;
}
